// API service configuration for SpynERP — single source for API base URL. Change here for production.
const API_BASE_URL = 'https://spynerp.com/api';

const getHeaders = (includeAuth = true): HeadersInit => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  const token = localStorage.getItem('auth_token');
  if (includeAuth && token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

/** On 401: clear invalid token and redirect to login so user can re-authenticate */
function handle401(authenticated: boolean) {
  if (authenticated) {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    window.location.href = '/login';
  }
}

async function parseResponse<T>(response: Response, authenticated: boolean): Promise<T> {
  if (response.status === 401) {
    handle401(authenticated);
  }
  return response.json();
}

export const api = {
  baseURL: API_BASE_URL,

  async get(endpoint: string, authenticated = true) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: getHeaders(authenticated),
    });
    return parseResponse(response, authenticated);
  },

  async post(endpoint: string, data: unknown, authenticated = true) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: getHeaders(authenticated),
      body: JSON.stringify(data),
    });
    return parseResponse(response, authenticated);
  },

  async put(endpoint: string, data: unknown, authenticated = true) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: getHeaders(authenticated),
      body: JSON.stringify(data),
    });
    return parseResponse(response, authenticated);
  },

  async delete(endpoint: string, authenticated = true) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: getHeaders(authenticated),
    });
    return parseResponse(response, authenticated);
  },

  async upload(endpoint: string, formData: FormData, authenticated = true) {
    const headers: HeadersInit = { Accept: 'application/json' };
    const token = localStorage.getItem('auth_token');
    if (authenticated && token) {
      (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers,
      body: formData,
    });
    return parseResponse(response, authenticated);
  },
};

export default api;
